// rbac.service.ts
import { Injectable } from '@angular/core';
import { UserService } from 'app/core/user/user.service';

@Injectable({ providedIn: 'root' })
export class RbacService {
  private roles: Set<String> = new Set();

  constructor(
    userService : UserService
  ){
    userService.user$.subscribe(user => this.setRoles(user.roles))
  }

  setRoles(roles: String[]) {
    this.roles = new Set(roles);
  }

  has(role: String): boolean {
    return this.roles.has(role);
  }

  hasAny(roles: String[]): boolean {
    return roles.some(r => this.roles.has(r));
  }

  hasAll(roles: String[]): boolean {
    return roles.every(r => this.roles.has(r));
  }
}